import React from 'react';

const AddFolder = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M2.4625 13C2.40176 13 9.5 13 9.5 13H2.5C2.22386 13 2 12.7761 2 12.5V12.5C2 12.5 2 12.5982 2 12.5375V5H13.5V5C13.7761 5 14 5.22314 14 5.49928C14 6.20155 14 7.40648 14 7.5"
        stroke="#80858F"
        stroke-width="1.25"
        stroke-linecap="round"
      />
      <path
        d="M1.375 5.00014V5.62514H2.625V5.00014H1.375ZM5.79375 2.00014V2.62515L5.79594 2.62514L5.79375 2.00014ZM8.05805 4.94218L8.49998 5.38413L9.38388 4.50026L8.94195 4.05831L8.05805 4.94218ZM2 5.00014H2.625V2.50014H2H1.375V5.00014H2ZM2.5 2.00014V2.62514H5.79375V2.00014V1.37514H2.5V2.00014ZM5.79375 2.00014L5.79594 2.62514C5.79681 2.62514 5.7977 2.62513 5.7986 2.62513L5.79657 2.00013L5.79454 1.37514C5.79353 1.37514 5.79254 1.37514 5.79156 1.37515L5.79375 2.00014ZM6.14375 2.14389L5.7018 2.58583L8.05805 4.94218L8.5 4.50024L8.94195 4.05831L6.5857 1.70196L6.14375 2.14389ZM5.79657 2.00013L5.7986 2.62513C5.75925 2.62526 5.72563 2.60954 5.7029 2.58693L6.14375 2.14389L6.5846 1.70086C6.37728 1.49456 6.0943 1.37416 5.79454 1.37514L5.79657 2.00013ZM2 2.50014H2.625C2.625 2.56918 2.56904 2.62514 2.5 2.62514V2.00014V1.37514C1.87868 1.37514 1.375 1.87882 1.375 2.50014H2Z"
        fill="#80858F"
      />
      <g clip-path="url(#clip0_10463_71876)">
        <path
          d="M12.1641 8.17188V13.8287"
          stroke="#80858F"
          stroke-width="1.25"
          stroke-linecap="round"
        />
        <path
          d="M9.33594 11H14.9928"
          stroke="#80858F"
          stroke-width="1.25"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10463_71876">
          <rect width="8" height="8" fill="white" transform="translate(8 7)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddFolder;
